<template>
    <NuxtLayout name="malt-full-layout">
        <main>
            <slot />
        </main>

        <ClientOnboarding />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {ClientOnboarding} from '#components';
    import {useHead, useHostSettings, useScripts} from '#imports';

    const hostSettings = await useHostSettings();
    const {loadScripts} = useScripts(hostSettings);
    useHead({script: await loadScripts()});
</script>
